// ========================================
// COMPONENTS / AvailableOn.jsx
// ========================================

import React from "react";
import styles from "./AvailableOn.module.css";

const PLATFORMS = [
  { name: "Deliveroo", src: "/deliveroo.png",   href: "https://deliveroo.ae/menu/dubai/damac-hills/moon-berry?utm_campaign=organic&utm_medium=referrer&utm_source=menu_share" },
  { name: "Noon",      src: "/yellow.png",       href: "https://www.noon.com/en-ae/p-465610?utm_source=C1000207L&utm_medium=referral" },
  { name: "Amazon.ae", src: "/amazon-1.png",    href: "https://www.amazon.ae/" },
  { name: "Carrefour", src: "/garrdefor.png",   href: "https://www.carrefouruae.com" },
];

export default function AvailableOn() {
  return (
    <section className={styles.section}>
      <h2 className={styles.title}>Also available on</h2>
      <div className={styles.divider} />
      <div className={styles.logos}>
        {PLATFORMS.map(({ name, src, href }) => (
          <a key={name} href={href} target="_blank" rel="noopener noreferrer" className={styles.logoBox}>
            <img src={src} alt={name} className={styles.logo} />
          </a>
        ))}
      </div>
    </section>
  );
}
